import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState, useContext, useMemo} from "react";
import {SwalAlertClass, SwalAlertChoice} from "core/swalClass";
// -
import NavBreadcrum from "components/NavBreadcrum";
import TopBarActions from "components/TopBarActions";
import TableRouteStatic from "./route-static/TableRouteStatic";
import PrevRoutes from "./route-static/PrevRoutes";
import FormRouteStatic from "./route-static/FormRouteStatic";
import {RouteStaticModel} from "site-apps/distribution/route/RouteStaticModel";
import ButtonsActions from "views/utils/buttonsActions";
import navs from "./navs";
import axiApi from "ApiCaller";
import {useNavigate} from "react-router-dom";
import AuthContext from "context/AuthContext";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import OrderingModel from "components/ordering/OrderingModel";
import ItemsModel from "core/itemsModel";
import useCustomTranslation from "core/customTranslation";
import translations from "./route-static/translations";

const ViewRouteStatic = () => {
    const {user} = useContext(AuthContext);
    const navigate = useNavigate();
    const {t: _Tr} = useTranslation("routes");
    const {t: _Tt} = useTranslation("tables");
    const {t: _CT} = useCustomTranslation(translations);
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const AlertQuestion = new SwalAlertChoice({
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
    });
    document.title = _Tr("labels.routes-static");
    const [buttonsTB, setButtonsTB] = useState({
        ...new ButtonsActions(),
        title: document.title,
    });
    const bread = useMemo(
        () => [
            {name: _Tr("labels.route-management"), url: "/route-management", current: false},
            {name: _Tr("labels.routes-static"), current: true},
        ],
        [_Tr],
    );
    const items = useRef(new ItemsModel());
    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const paramsTypes = useRef({});
    const orderingRef = useRef(new OrderingModel());

    const [isLoading, setIsLoading] = useState(false);
    const [itemsShown, setItemsShown] = useState([]);
    const [item, setItem] = useState({...RouteStaticModel});
    const [showPrev, setShowPrev] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [checkAll, setCheckAll] = useState(false);

    const headersTable = useMemo(
        () => [
            {name: _Tt("common.name"), attr: 0, direction: "asc", active: true, default: true},
            {name: _Tt("common.description"), attr: 1, direction: "asc", active: false},
            {name: _Tt("containers.download_type"), attr: 2, direction: "asc", active: false},
            {name: _Tt("common.wastes"), attr: 3, direction: "asc", active: false},
            {name: _Tt("common.stations"), attr: 4, direction: "asc", active: false, disabled: true},
            {name: _Tt("common.duration"), attr: 5, direction: "asc", active: false, disabled: true},
        ],
        [_Tt],
    );

    useEffect(() => {
        // Verificar si el usuario es administrador
        const canEdit = user && (user.is_superuser || user.is_admin);

        const buttons = {...buttonsTB};
        buttons.title = document.title;

        buttons.add.active = canEdit;
        buttons.add.disabled = !canEdit;
        buttons.add.onClick = onClickAdd;

        buttons.edit.active = canEdit;
        buttons.edit.disabled = true;
        buttons.edit.onClick = onClickEdit;

        buttons.duplicate.active = canEdit;
        buttons.duplicate.disabled = true;
        buttons.duplicate.onClick = onClickDuplicate;

        buttons.delete.active = canEdit;
        buttons.delete.disabled = true;
        buttons.delete.onClick = onClickDelete;

        buttons.filter.active = false;
        buttons.export.active = false;
        buttons.addPlus.active = false;
        buttons.editColumn.active = false;
        setButtonsTB(buttons);
        pagerModelRef.current.active = true;
        pagerModelRef.current.handleCallApi = () => {
            fetchRoutes();
        };
        orderingRef.current.setHeaders(headersTable);
        orderingRef.current.applyOrder = () => fetchRoutes();
        items.current.setItem = setItem;
        items.current.setShowPrev = setShowPrev;
        items.current.item = RouteStaticModel;

        fetchGetRoutes();
    }, []);
    filters.current.filter = () => {
        pagerModelRef.current.paging.page = 1;
        fetchRoutes();
    };

    const fetchGetRoutes = () => {
        setIsLoading(true);
        axiApi
            .get("/api/distribution/static/routes/")
            .then((resp) => {
                paramsTypes.current = resp.data.params.filters;
                setItemsShown([...resp.data.items]);
                items.current.showed = [...resp.data.items];
                if (resp.data && resp.data.pager) {
                    pagerModelRef.current.paging.update(resp.data.pager);
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const fetchRoutes = () => {
        setIsLoading(true);
        axiApi
            .post(`/api/distribution/static/routes/`, filters.current.chosen, {
                params: {...pagerModelRef.current.paging.getParams(), ...orderingRef.current.getParams()},
            })
            .then((resp) => {
                setItemsShown([...resp.data.items]);
                items.current.setShowed(resp.data.items);
                if (resp.data && resp.data.pager) {
                    pagerModelRef.current.paging.update(resp.data.pager);
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const onClickAdd = () => {
        setItem({...RouteStaticModel});
        setShowForm(true);
    };

    const onClickEdit = () => {
        if (items.current.chosen.length > 1 || items.current.chosen.length === 0) {
            return false;
        }
        let idx = items.current.showed.findIndex((item) => item.id === items.current.chosen[0]);
        let route = {...items.current.showed[idx]};
        route.idx = idx;
        setItem(route);
        setShowForm(true);
    };

    const onClickDuplicate = () => {
        if (items.current.chosen.length !== 1) {
            return false;
        }
        const route = items.current.showed.find((item) => item.id === items.current.chosen[0]);
        axiApi
            .post("/api/distribution/static/route/duplicate/", {
                id: route.id,
                name: `${route.name} ${_CT("duplicate-suffix")}`,
            })
            .then((resp) => {
                if (resp.data.status) {
                    Alert.success(_CT("duplicate-ok-title"), _CT("duplicate-ok-text"));
                    fetchRoutes();
                } else {
                    Alert.error(_CT("duplicate-error"));
                }
            })
            .catch((error) => {
                console.error(error);
                Alert.error(_CT("duplicate-error"));
            });
    };

    const onClickDelete = () => {
        let ids = items.current.getChosenIds();
        let idx = items.current.showed.findIndex((item) => item.id === items.current.chosen[0]);
        let name = items.current.showed[idx].name;

        axiApi
            .post(`/api/distribution/static/routes/info/`, {ids})
            .then((resp) => {
                if (resp.data.isInUse) {
                    AlertQuestion.warning(
                        "La ruta está en uso",
                        `La ruta: ${name} está en uso en programación. ¿Desea eliminarla igualmente?`,
                    ).then((r) => {
                        if (!r.isConfirmed) return;

                        proceedToDelete();
                    });
                } else {
                    AlertQuestion.warning("Se eliminará", `La ruta: ${name}`).then((r) => {
                        if (!r.isConfirmed) return;

                        proceedToDelete();
                    });
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
                if (error.response && error.response.status === 403) {
                    navigate("/");
                }
            });
    };

    const proceedToDelete = () => {
        setItem({...RouteStaticModel});
        setShowPrev(false);

        let ids = items.current.getChosenIds();

        axiApi
            .delete("/api/distribution/static/routes/", {data: {ids}})
            .then((r) => {
                if (r.data.status) {
                    Alert.success("Confirmado", "Se han eliminado correctamente");
                    fetchRoutes();
                } else {
                    Alert.warning("Error en el servicio", "No se sabe si se han podido eliminar las rutas");
                }
            })
            .catch((err) => {
                console.error(err);
            });
    };

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <TopBarActions actions={buttonsTB} filtersRef={filters} />
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="125px" chosen={items.current.chosen} />
            {showForm ? (
                <FormRouteStatic
                    title={buttonsTB.title}
                    show={showForm}
                    setShow={setShowForm}
                    item={item}
                    setItem={setItem}
                    params={paramsTypes}
                    items={items}
                    setItems={setItemsShown}
                />
            ) : (
                <></>
            )}
            <div className="row">
                <div className="col-md col-12">
                    <LoaderSpinner isLoading={isLoading}>
                        <TableRouteStatic
                            itemsShow={itemsShown}
                            setItemsShow={setItemsShown}
                            items={items}
                            checkAll={checkAll}
                            setCheckAll={setCheckAll}
                            buttonsTB={buttonsTB}
                            setButtonsTB={setButtonsTB}
                            orderingRef={orderingRef}
                        />
                    </LoaderSpinner>
                </div>
                {showPrev ? (
                    <div className="col-md col-12 prev-item" style={{maxWidth: "300px"}}>
                        <PrevRoutes item={item} showPreview={showPrev} paramsTypes={paramsTypes} routes={itemsShown} />
                    </div>
                ) : (
                    <> </>
                )}
            </div>
        </>
    );
};

export default ViewRouteStatic;
